import {
  ICON_BRIEFCASE_OUTLINE, ICON_CROWN_OUTLINE, ICON_EMOTICON_HAPPY_OUTLINE, ICON_FLAG_OUTLINE, ICON_SWORD,
} from '@doveit/bricks';
import { TargetAgentType } from '../../../providers/api/dtos';

export const configByAgentProfile: Record<TargetAgentType, {
  title: string,
  color: string,
  icon: string,
  description: string,
}> = {
  COMMON: {
    title: 'Agente Base',
    color: 'info',
    icon: ICON_EMOTICON_HAPPY_OUTLINE,
    description: 'Ha un\'ambizione economica contenuta e ben definita; lavora per raggiungere un guadagno minimo sufficiente, con un\'attività snella, pochi incarichi e bassa pressione.',
  },
  ACTIVE: {
    title: 'Agente Operativo',
    color: 'info',
    icon: ICON_BRIEFCASE_OUTLINE,
    description: 'Mira a un guadagno medio e costante, gestendo un buon flusso di trattative. Lavora in modo ordinato e puntuale, con obiettivi chiari e un focus sul rendimento regolare.',
  },
  COMPETITIVE: {
    title: 'Agente Competitivo',
    color: 'success',
    icon: ICON_SWORD,
    description: 'Persegue un guadagno alto, con l\'intento di superare i propri limiti e crescere velocemente. È orientato al risultato, misura le performance e cerca visibilità nel mercato.',
  },
  DOMINATIVE: {
    title: 'Agente Dominante',
    color: 'success',
    icon: ICON_FLAG_OUTLINE,
    description: 'Ha un\'ambizione molto alta, lavora per posizionarsi tra i top producer, con obiettivi economici ambiziosi, grande intensità operativa e una forte presenza nel mercato.',
  },
  LEGENDARY: {
    title: 'Agente Leggendario',
    color: 'warning',
    icon: ICON_CROWN_OUTLINE,
    description: 'Spinto da un\'ambizione estrema, lavora per esprimere il massimo potenziale personale possibile, sfruttando al meglio le proprie capacità operative, strategiche e di rendimento economico',
  },
};
